import React from 'react'
import { Outlet } from 'react-router-dom'
import SideMenu from './components/SideMenu'
import './dashboard.css'

export default function Dashboard() {
  return (
    <div className="dashboard-main-container upper-container">
        <SideMenu />
        <div className="dashboard-container">
          <Outlet />
        </div>
    </div>
  )
}
